import * as yup from 'yup';
import { VALIDATION_MESSAGES } from '../constants/validationMessages';

export const EDIT_PROFILE_VALIDATION = yup.object({
  firstName: yup
    .string()
    .trim()
    .required(VALIDATION_MESSAGES.REQUIRED_FIRST_NAME),
  lastName: yup
    .string()
    .trim()
    .required(VALIDATION_MESSAGES.REQUIRED_LAST_NAME),
  nickname: yup.string().trim().nullable(),
  industry: yup.string().trim().nullable(),
  team: yup.string().trim().nullable(),
  jobFunction: yup.string().trim().nullable(),
  techStack: yup
    .array()
    .of(yup.string().trim())
    .min(1, VALIDATION_MESSAGES.REQUIRED_TECH_STACK),
  tools: yup
    .array()
    .of(yup.string().trim())
    .min(1, VALIDATION_MESSAGES.REQUIRED_TOOLS),
});